import {
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { primaryColor, textColor } from "../assets/colors/colors";
import styles from "./index.module.scss";

export interface NavItemProps {
  selected: boolean;
  nav: any;
}

const NavItem = (props: NavItemProps) => {
  return (
    <ListItem
      selected={props.selected}
      classes={{ selected: styles.listItemSelected }}
    >
      <ListItemIcon
        style={{
          color: props.selected ? primaryColor : textColor,
          minWidth: "40px",
        }}
      >
        {props.nav.icon}
      </ListItemIcon>
      <ListItemText>
        <Typography className={styles.listItemText}>
          {props.nav.label}
        </Typography>
      </ListItemText>
    </ListItem>
  );
};

export default NavItem;
